import * as React from 'react';
import * as styles from './Replay.css';
import { LocalizationService } from '../../../services/LocalizationService';
import { inject, observer } from 'mobx-react';
import { Store } from '../stores';
import { IAToggle } from '../../toggle/Toggle';
import { IAEditor } from '../../editor/Index';
import { IAMessageBar } from '../../messageBar/MessageBar';
import { FeedStructureViewer } from '../../feedStructureViewer/FeedStructureViewer';
import { Cover } from '../cover/Cover';
import { IComposerImage } from '../../../interfaces/IComposerImage';
import { Helper } from '../../../Helper';
import { Environment } from '../../../services/Environment';
import { IComposerVideo } from '../../../interfaces/IComposerVideo';

export interface IProps {
  onChange: () => void;
  store?: Store;
}

export interface IState {
  showController: boolean;
}

@inject('store')
@observer
export class Replay extends React.Component<IProps, IState> {

  private readonly localizationService: LocalizationService = new LocalizationService();

  constructor(props: IProps) {
    super(props);
    this.state = {
      showController: false
    }
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public componentDidMount(): void {
    // Some replay settings are not present for existing messages
    if (this.props.store.configuration.replay.id === undefined) {
      this.props.store.configuration.replay = {
        ...this.props.store.configuration.replay,
        id: "Replay",
        type: "cover",
        typeToEdit: "image",
        image: {
          source: "Link",
        },
        video: {
          source: "Link",
        }
      }
    }
  }

  private showToolbox(): void {
    this.setState({ showController: true });
  }

  private hideToolbox(): void {
    this.setState({ showController: false });
  }

  private getFeedApplication(): "messages" | "events" {
    if (this.props.store.component === "Messages") {
      return "messages";
    }
    if (this.props.store.component === "Event") {
      return "events";
    }
    return undefined;
  }

  public render(): JSX.Element {
    return (
      <div
        className={styles.IA_replay}
      >
        <IAToggle
          label={this.localizationService.strings.Messages_EditPanel_PublishToFeeds}
          checked={this.props.store.publishToReplay}
          color={this.props.store.highlightColor}
          onChange={() => {
            this.props.store.publishToReplay = !this.props.store.publishToReplay;
            if (!this.props.store.publishToReplay) {
              this.props.store.selectedFeeds = [];
            }
          }}
        />
        <IAMessageBar
          type="information"
          onDismiss={() => { }}
          icon="Info"
          showIcon
          content={<span>{this.localizationService.strings.Composer_FeedMessageInfo}</span>}
          showCloseButton={false}
          justifyContent="left"
          style={{
            clear: "both",
            float: "left",
            borderRadius: 5,
            padding: "0 20px",
            marginTop: 20,
            opacity: this.props.store.publishToReplay ? 1 : 0.5,
            width: "calc(100% - 40px)"
          }}
        />
        <div
          style={{
            clear: 'both',
            marginLeft: 0,
            marginTop: 20,
            float: "left",
            display: 'flex',
            flexDirection: 'column',
            pointerEvents: this.props.store.publishToReplay ? "unset" : "none",
            opacity: this.props.store.publishToReplay ? 1 : 0.5
          }}
        >
          <div style={{
            width: "100%",
            float: "left",
            marginBottom: 10
          }}>
            {this.localizationService.strings.Composer_AvailableReplayFeeds}
          </div>

          <FeedStructureViewer
            tenant={this.props.store.tenant}
            environment={this.props.store.environment}
            application={this.getFeedApplication()}
            highlightColor={this.props.store.highlightColor}
            availableFeeds={this.props.store.feedOptions}
            selectedFeedIds={this.props.store.selectedFeeds}
            instanceName={this.props.store.instance.instanceName}
            onFeedSelectedChange={(feed, isChecked) => {
              if (isChecked) {
                this.props.store.selectedFeeds.push(feed.id);
              }
              else {
                this.props.store.selectedFeeds = [...this.props.store.selectedFeeds.filter(id => id !== feed.id)]
              }
              this.forceUpdate();
            }}
          />

          {!this.props.store.validateReplayFeed() &&
            <div
              className={styles.IA_replay_error_message}
              style={{
                clear: "both",
                float: "left"
              }}
            >
              {this.localizationService.strings.Composer_ReplayFeedValidation}
            </div>
          }
        </div>
        <IAToggle
          label={this.localizationService.strings.Composer_ReplayContentOnlyImage}
          checked={this.props.store.configuration?.replay?.boxStyle === "onlyImage"}
          disabled={!this.props.store.publishToReplay || this.props.store.configuration?.replay?.boxStyle === "onlyVideo"}
          color={this.props.store.highlightColor}
          onChange={() => {
            if (!this.props.store.configuration?.replay) {
              this.props.store.configuration.replay = {
                boxStyle: undefined
              };
            }
            if (this.props.store.configuration?.replay) {
              this.props.store.configuration.replay.boxStyle = this.props.store.configuration?.replay?.boxStyle == undefined ? "onlyImage" : undefined;
            }
            this.forceUpdate();
          }}
          style={{
            marginTop: 20
          }}
        />
        <IAToggle
          label={this.localizationService.strings.Composer_ReplayContentOnlyVideo}
          checked={this.props.store.configuration?.replay?.boxStyle === "onlyVideo"}
          disabled={!this.props.store.publishToReplay || this.props.store.configuration?.replay?.boxStyle === "onlyImage"}
          color={this.props.store.highlightColor}
          onChange={() => {
            if (!this.props.store.configuration?.replay) {
              this.props.store.configuration.replay = {
                boxStyle: undefined
              };
            }
            if (this.props.store.configuration?.replay) {
              this.props.store.configuration.replay.boxStyle = this.props.store.configuration?.replay?.boxStyle == undefined ? "onlyVideo" : undefined;
            }
            this.forceUpdate();
          }}
          style={{
            marginTop: 20
          }}
        />
        <div style={{
          width: "100%",
          float: "left",
          marginTop: 20,
        }}>
          {this.localizationService.strings.Composer_ReplayMedia}
        </div>
        <div
          style={{
            position: "relative",
            float: "left",
            width: "100%",
            marginLeft: -40
          }}
        >
          <Cover
            id={this.props.store.configuration.replay.id}
            image={this.props.store.configuration.replay.image}
            video={this.props.store.configuration.replay.video}
            typeToEdit={this.props.store.activeComponent && this.props.store.activeComponent.typeToEdit}
            hideToolbox={this.props.store.activeComponent && this.props.store.activeComponent.id !== "Replay"}
            showDropZones={this.props.store.componentToAdd != undefined}
            isMobile={this.props.store.isMobile}
            onChangeImage={(image: IComposerImage) => {
              this.props.store.configuration.replay.image = image;
              if (this.props.store.tenantSettings?.admin?.useBlobImages && !this.props.store.isMessagesTemplateEditor) {
                Helper.getImageBlobUrl(Environment.getEnvironmentForImageAPI(this.props.store.environment), this.props.store.tenant, image.url, image.modified, "Full", image?.cropSettings).then((blobUrl) => {
                  this.props.store.configuration.replay.image.imageBlobUrl = blobUrl;
                  this.forceUpdate();
                })
              }
              else {
                this.forceUpdate();
              }
            }}
            onChangeVideo={(video: IComposerVideo) => {
              this.props.store.configuration.replay.video = video;
              this.forceUpdate();
            }}
            onFocus={() => {
              this.props.store.activeComponent = this.props.store.configuration.replay;
              this.forceUpdate();
            }}
          />
        </div>
        <div style={{
          width: "100%",
          float: "left",
          marginTop: 20,
          opacity: this.props.store.publishToReplay && this.props.store.configuration.replay?.boxStyle !== "onlyImage" ? 1 : 0.5,
        }}>
          {this.localizationService.strings.Composer_ReplayContent}
        </div>
        <div
          id={"IA_ComposerReplayContent"}
          style={{
            position: "relative",
            float: "left",
            width: "100%"
          }}
        >
          <IAEditor
            placeholder={this.localizationService.strings.Composer_TypeHere}
            token={this.props.store.token}
            tenant={this.props.store.tenant}
            environment={this.props.store.environment}
            isMobile={this.props.store.isMobile}
            highlightColor={this.props.store.highlightColor}
            content={this.props.store.configuration?.replay?.content}
            hideToolbox={!this.state.showController}
            fontStyleSupport
            listsSupport
            clearStylingSupport
            emojiSupport
            style={{
              width: "100%",
              minHeight: 325,
              border: !this.props.store.validateReplayContentHeight() ? "1px solid red" : "1px solid #cbcbcb",
              borderRadius: 5,
              padding: 5,
              boxSizing: "border-box",
              pointerEvents: this.props.store.publishToReplay && this.props.store.configuration?.replay?.boxStyle !== "onlyImage" ? "unset" : "none",
              opacity: this.props.store.publishToReplay && this.props.store.configuration?.replay?.boxStyle !== "onlyImage" && this.props.store.configuration?.replay?.boxStyle !== "videoImage" ? 1 : 0.5,
              float: "left",
              marginTop: 10,
              marginBottom: 20
            }}
            onChange={(editorHtml) => {
              this.props.store.configuration.replay.content = editorHtml;
              let contentElement = document.getElementById("IA_ComposerReplayContent");
              this.props.store.replayContentTooHigh = contentElement?.clientHeight > 360;
              this.props.onChange();
            }}
            onStyleChange={() => { }}
            onFocus={() => {
              setTimeout(() => {
                this.showToolbox();
              }, 0);
            }}
            onBlur={() => {
              setTimeout(() => {
                this.hideToolbox();
              }, 10);
            }}
          />
        </div>
        {!this.props.store.validateReplayContentHeight() &&
          <div
            className={styles.IA_replay_error_message}
            style={{
              clear: "both",
              float: "left",
              marginBottom: 20,
              marginTop: 0
            }}
          >
            {this.localizationService.strings.Composer_ReplayContentTooLong}
          </div>
        }
      </div>
    );
  }


}
